export const FULLTEXT_STORES = ['fulltexten', 'fulltextfr', 'fulltextde'];
